export default "__VITE_ASSET__CXvB8nqc__"